/**
 * Dependencies
 */
import http from '../../../../../services/HttpService'

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * Get the project data from the API
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const getProjectData = ({ commit, getters }, id) => {
    Promise.all([
        http.get(`projects/${id}/activity/?type=top_users&scope=${getters.contextQueryString}`),
        http.get(`projects/${id}/activity/?type=geolocation&scope=${getters.contextQueryString}`),
        http.get(`projects/${id}/activity/?scope=${getters.contextQueryString}`)
    ])
    .then(res => {
        commit('SET_TOP_USERS', res[0].data)
        commit('SET_GEOLOCATION', res[1].data.filter(
            point => point.location.lat && point.location.lon
        ))
        commit('SET_ACTIVITY', res[2].data)
        commit('LOADING_COMPLETED')
    })
    .catch(err => console.log(err))
}

/**
 * Get the histogram data for a project
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Number} id
 * @return {Void}
 */
const getHistogramData = ({ commit, state, getters }, id) => {
    return http.get(`projects/${id}/activity/?type=histogram&bin=${state.histogram.type}&scope=${getters.contextQueryString}`)
        .then(res => {
            commit('SET_HISTOGRAM', res.data)
            return res.data
        })
        .catch(err => console.log(err))
}

/**
 * Change histogram key
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const changeHistogramKey = ({ commit }, key) => {
    commit('CHANGE_HISTOGRAM_KEY', key)
}

/**
 * Update the activity context
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
const updateActivityContext = ({ commit, state }, payload) => {
    let context = state.context

    if (state.context.includes(payload.type) && !payload.checked) {
        commit('UPDATE_CONTEXT', context.filter(item => item !== payload.type))
    }

    if (!state.context.includes(payload.type) && payload.checked) {
        context.push(payload.type)
        commit('UPDATE_CONTEXT', context)
    }
}

export default {
    resetState,
    getProjectData,
    getHistogramData,
    changeHistogramKey,
    updateActivityContext
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/activity/actions.js